
export class DrawerComponentsEnum {
    static readonly NOTIFICATIONS = 1;
}